import progressGr16_202307Module from '../reports/progress-gr1-6-2023-07/index.js';
import progressGr78_202307Module from '../reports/progress-gr7-8-2023-07/index.js';
import provincialGr16_202309Module from '../reports/provincial-gr1-6-2023-09/index.js';
import provincialGr78_202309Module from '../reports/provincial-gr7-8-2023-09/index.js';
import provincialGr912_202202SemModule from '../reports/provincial-gr9-12-2022-02-sem/index.js';
import kindergartenInitial_201606Module from '../reports/kindergarten-initial-2016-06/index.js';
import kindergartenFinal_202309Module from '../reports/kindergarten-final-2023-09/index.js';

export const REPORT_TYPES = [
  {
    value: "kindergarten_initial_2016_06",
    label: "Kindergarten Communication of Learning",
    badgeLabel: "KG - Initial",
    demoLabel: "Kindergarten - Initial",
    subtitle: "Initial Observations (JK / SK)",
    description: "Ontario's fall-term kindergarten report - narrative observations of the child's learning in a play-based environment.",
    pdfPreview: kindergartenInitial_201606Module.templateUrl,
    grades: ["K"],
    disabled: false,
    registryKey: 'kindergarten_initial_2016_06',
    demoPath: '/demo/kindergarten_initial_2016_06',
  },
  {
    value: "kindergarten_final_2023_09",
    label: "Kindergarten Communication of Learning",
    badgeLabel: "KG - Final",
    demoLabel: "Kindergarten - Final",
    subtitle: "Final Observations (JK / SK)",
    description: "Ontario's year-end kindergarten report - narrative observations across the four frames, with the Early Reading Screening for Year 2.",
    pdfPreview: kindergartenFinal_202309Module.templateUrl,
    grades: ["K"],
    disabled: false,
    registryKey: 'kindergarten_final_2023_09',
    demoPath: '/demo/kindergarten_final_2023_09',
  },
  {
    value: "pgrc1to6_2023_07",
    label: "Progress Report",
    subtitle: "Grades 1-6",
    description: "Ontario's standard elementary progress report covering learning skills and subject areas.",
    pdfPreview: progressGr16_202307Module.templateUrl,
    grades: [1, 2, 3, 4, 5, 6],
    disabled: false,
    registryKey: 'pgrc1to6_2023_07',
    demoPath: '/demo/pgrc1to6_2023_07',
  },
  {
    value: "pgrc7to8_2023_07",
    label: "Progress Report",
    subtitle: "Grades 7-8",
    description: "Ontario's standard junior/intermediate progress report covering learning skills and subject areas.",
    pdfPreview: progressGr78_202307Module.templateUrl,
    grades: [7, 8],
    disabled: false,
    registryKey: 'pgrc7to8_2023_07',
    demoPath: '/demo/pgrc7to8_2023_07',
  },
  {
    value: "pvrc1to6_2023_09",
    label: "Provincial Report",
    subtitle: "Grades 1-6",
    description: "Full provincial report card with detailed subject-by-subject letter grades.",
    pdfPreview: provincialGr16_202309Module.templateUrl,
    grades: [1, 2, 3, 4, 5, 6],
    disabled: false,
    registryKey: 'pvrc1to6_2023_09',
    demoPath: '/demo/pvrc1to6_2023_09',
  },
  {
    value: "pvrc7to8_2023_09",
    label: "Provincial Report",
    subtitle: "Grades 7-8",
    description: "Full provincial report card for Grades 7-8 with History and Geography.",
    pdfPreview: provincialGr78_202309Module.templateUrl,
    grades: [7, 8],
    disabled: false,
    registryKey: 'pvrc7to8_2023_09',
    demoPath: '/demo/pvrc7to8_2023_09',
  },
  {
    value: "pvrc9to12_2022_02_sem",
    label: "Provincial Report",
    subtitle: "Grades 9-12",
    description: "Full provincial report card for Grades 9-12 with semester-based course tracking and credit summary.",
    pdfPreview: provincialGr912_202202SemModule.templateUrl,
    grades: [9, 10, 11, 12],
    disabled: false,
    registryKey: 'pvrc9to12_2022_02_sem',
    demoPath: '/demo/pvrc9to12_2022_02_sem',
  }
];

// Short label for the compact folder-card badge. Falls back to the full label
// for types that don't define one (most are already short, e.g. "Progress Report").
export function getTypeLabelByValue(value) {
  const t = REPORT_TYPES.find((t) => t.value === value);
  return t?.badgeLabel ?? t?.label ?? value;
}
